/**
 * Link targets
 * @module gui/components/link/target
 */

/**
 * Links to the web app
 */
export const LINK_TARGET_BLANK = 'blank'
